import Loadable from "react-loadable";

export const ConnectInvestorButton = Loadable({
  loader: () => import("../../../../modules/manage-pitch").then((module) => module.ConnectInvestorButton) as Promise<any>,
  loading: () => null,
});
